module.exports = __webpack_public_path__ + "img/bg.146d6a13.png";